import React from 'react';
import FamilyCardRo from './FamilyCardRo';

const body = [
  'Dr. Amara Osei a organizat Colectivul Medical al Conștiinței în 2093 — inițiativa care a <strong class="text-white">eliminat cancerul, bolile cardiovasculare și neurodegenerarea</strong> în cincisprezece ani.',
  'Urmașii ei au devenit biologii sistemului solar exterior: prezenți la descoperirea vieții pe Europa, conducând Proiectul de Conservare Enceladus, protejând dansatorii lunii muribunde de-a lungul generațiilor.',
  'Linia Osei-Okonkwo reprezintă arcul moral central al cărții: o familie care a început prin vindecarea corpurilor umane și a evoluat, de-a lungul secolelor, în <strong class="text-white">gardieni ai vieții non-umane</strong>. Prezența lor recurentă în cronică este povestea a ceea ce devin oamenii când aleg, consecvent, să protejeze în loc să exploateze.',
];

const FamilyOseiRo = () => (
  <FamilyCardRo
    id="family-ro-2"
    accentColor="text-green-400"
    dotColor="bg-green-400"
    borderColor="border-green-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-green-900/10 via-transparent to-transparent"
    tag="Vindecătorii și Gardienii · Pământ / Venus / Enceladus"
    name="Familia Osei-Okonkwo"
    origin="Pământ · Venus · Enceladus"
    body={body}
    quote="Suntem o specie care salvează dansatori."
    quoteSource="Dr. Chiamaka Okonkwo-Matsumoto, Directoarea Proiectului de Conservare Enceladus, 2501"
  />
);

export default FamilyOseiRo;